/**
 * WineDepo 21+ age gate
 * Shows until the visitor confirms age (localStorage).
 */
(function () {
  var gate = document.getElementById('wd-age-gate');
  if (!gate) return;

  var KEY = gate.getAttribute('data-storage-key') || 'wd_age_verified_v1';

  function passed() {
    try {
      return window.localStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function remember() {
    try {
      window.localStorage.setItem(KEY, '1');
    } catch (e) {
      /* private mode */
    }
  }

  function openGate() {
    gate.hidden = false;
    gate.removeAttribute('hidden');
    gate.classList.add('is-open');
    document.documentElement.classList.add('wd-age-gate-lock');
    document.documentElement.classList.remove('wd-age-gate-passed');
  }

  function closeGate() {
    gate.hidden = true;
    gate.setAttribute('hidden', '');
    gate.classList.remove('is-open');
    document.documentElement.classList.remove('wd-age-gate-lock');
    document.documentElement.classList.add('wd-age-gate-passed');
  }

  function accept() {
    remember();
    closeGate();
  }

  function deny() {
    var title = gate.getAttribute('data-denied-title') || 'Access restricted';
    var text = gate.getAttribute('data-denied-text') || '';
    gate.innerHTML =
      '<div class="wd-age-gate__backdrop"></div>' +
      '<div class="wd-age-gate__card">' +
      '<p class="wd-age-gate__brand">WineDepo</p>' +
      '<p class="wd-age-gate__mark" aria-hidden="true">21+</p>' +
      '<h2 class="wd-age-gate__title">' +
      title +
      '</h2>' +
      '<p class="wd-age-gate__text">' +
      text +
      '</p>' +
      '</div>';
    openGate();
  }

  if (passed()) {
    closeGate();
    return;
  }

  openGate();

  var yes = gate.querySelector('[data-wd-age-yes]');
  var no = gate.querySelector('[data-wd-age-no]');
  if (yes) yes.addEventListener('click', accept);
  if (no) no.addEventListener('click', deny);
})();
